import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../images/star.png';
import _imports_1 from '../../images/arrow_right.png';

const _withScopeId = n => (_pushScopeId("data-v-2ad94b56"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-warp pointer"
};
const _hoisted_2 = {
  key: 0,
  class: "info-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "main"
};
const _hoisted_5 = {
  class: ""
};
const _hoisted_6 = {
  class: "title-warp"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  key: 0,
  class: "rating"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_10 = {
  class: "info"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ukraine", -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Russia", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "132 min", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Anthony Russo,Joe Russo", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Robert Downey Jr,Robert Downey Jr,Chris Evans", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "121350", -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));

export default /*#__PURE__*/_defineComponent({
  __name: 'otherStyleCardItem',
  props: {
    infoItem: {
      type: Object,
      default: null
    },
    showImg: {
      type: Boolean,
      default: true
    },
    poster: {
      type: String,
      default: ''
    },
    programName: {
      type: String,
      default: ''
    },
    rating: {
      type: [String, Number],
      default: ''
    }
  },

  setup(__props) {
    const props = __props;
    console.log(66666, props.poster, props.programName);
    const isMore = ref(true);
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.showImg && __props.poster ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.poster,
        alt: ""
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(__props.programName), 1), __props.infoItem && __props.infoItem.type !== 'by_topic' && __props.infoItem.type !== 'all' ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(__props.rating), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [__props.infoItem && __props.infoItem.type !== 'by_topic' && __props.infoItem.type !== 'all' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Country')) + ":", 1), _hoisted_11]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Language')) + ":", 1), _hoisted_12]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Time')) + ":", 1), _hoisted_13]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Director')) + ":", 1), _hoisted_14]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Actor')) + ":", 1), _hoisted_15]),
        _: 1
      })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Total')) + ":", 1), _hoisted_16]),
        _: 1
      }), _hoisted_17], 64))])])])]);
    };
  }

});